import gsap from "gsap"

export const buildThresholdList = steps => {
  var thresholds = []
  var numSteps = steps
  for (var i = 1.0; i <= numSteps; i++) {
    var ratio = i / numSteps
    thresholds.push(ratio)
  }
  // thresholds.push(0)
  return thresholds
}

export const lockScroll = () => {
  document.width = window.innerWidth
  document.height = window.innerHeight
  document.body.style.overflow = "hidden"
  document.body.scroll = "no"
}

export const unlockScroll = () => {
  document.body.style.overflow = "scroll"
  document.body.scroll = "yes"
}

export const returnRectDifferences = (rect1, rect2) => {
  const xDif = rect1.x - rect2.x
  const yDif = rect1.y - rect2.y
  const xScaleRatio = rect1.width / rect2.width
  const yScaleRatio = rect1.height / rect2.height
  return { x: xDif, y: yDif, scaleX: xScaleRatio, scaleY: yScaleRatio }
}

export const scrollToId = id => {
  const targetElement = document.getElementById(id)
  // const scrollOffset = id === Sections.about.id ? 0 : 180
  const scrollOffset = 0
  const offsetTop = targetElement && targetElement.offsetTop
  // If nested, need to get parent items offset
  const offsetParent = targetElement && targetElement.offsetParent
  const offsetParentTop = offsetParent && offsetParent.offsetTop
  const scrollTo =
    offsetParentTop > 0
      ? offsetParentTop - scrollOffset
      : offsetTop - scrollOffset

  const duration = returnScrollDuration(scrollTo - window.scrollY)
  gsap.to(window, { duration: duration, scrollTo: scrollTo })
}

export const scrollToPosition = (position = 0) => {
  const duration = returnScrollDuration(window.scrollY - position)
  gsap.to(window, { duration: duration, scrollTo: position })
}

// Function adjusts duration based on distance so that it isn't really fast or really slow
const returnScrollDuration = distancePx =>
  Math.abs(Number(distancePx / 1200).toFixed(2))

export const copyStringToClipboard = async str => {
  navigator.clipboard.writeText(str).then(
    function() {
      /* clipboard successfully set */
      console.log("Written to clipboard")
      alert("Copied share link!")
    },
    function(error) {
      console.log("Failed", error)
      /* clipboard write failed */
    }
  )

  // MF: Check Clipboard API support in future: await navigator.clipboard.writeText(string);
  // var el = document.createElement("textarea")
  // el.value = str
  // el.setAttribute("readonly", "")
  // el.style = { position: "absolute", left: "-9999px" }
  // document.body.appendChild(el)
  // el.select()
  // document.execCommand("copy")
  // document.body.removeChild(el)
}

// const detectBrowser = () => {
//   let sBrowser,
//     sUsrAg = navigator.userAgent
//   // The order matters here, and this may report false positives for unlisted browsers
//   if (sUsrAg.indexOf("Firefox") > -1) {
//     sBrowser = "Mozilla Firefox"
//     // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
//   } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
//     sBrowser = "Samsung Internet"
//     // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
//   } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
//     sBrowser = "Opera"
//     // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
//   } else if (sUsrAg.indexOf("Trident") > -1) {
//     sBrowser = "Microsoft Internet Explorer"
//     // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
//   } else if (sUsrAg.indexOf("Edge") > -1) {
//     sBrowser = "Microsoft Edge"
//     // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
//   } else if (sUsrAg.indexOf("Chrome") > -1) {
//     sBrowser = "Google Chrome or Chromium"
//     // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
//   } else if (sUsrAg.indexOf("Safari") > -1) {
//     sBrowser = "Apple Safari"
//     // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
//   } else {
//     sBrowser = "Unknown"
//   }
//   setBrowser(sBrowser)
// }
